import { Component, OnInit } from '@angular/core';
import { ScriptsModule } from '../../../modules/scripts.module';
import { ActivatedRoute, Router } from '@angular/router';
import { IntermService } from '../../../services/general/interm.service';
import { Intermediario }    from '../../../obj/intermediario';
import { CotizadorService } from '../../../services/general/cotizador.service';
import { Cotizacion }    from '../../../obj/cotizacion';
import { CurrencyService } from '../../../services/currency.service';
import { PagerService } from '../../../services/extra/pager.service';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html',
  styleUrls: ['./cotizacion.component.css'],
  providers: [IntermService,CotizadorService,PagerService]
})
export class CotizacionComponent implements OnInit {
  public origen;
  public destino;
  public tipo;
  public estadia;

  public id;
  public model;

  public modelCotizacion;
  public resCotizacion;
  public polizas;

  public fechaIniCot;
  public fechaFinCot;


  //NOTIFICACION
  public tituloInterm;
  public mensajeInterm;
  public rutaInterm;
  // pager object
  pager: any = {};
  // paged items
  pagedItems: any[];
  public today;
  public da:Date;

  public conversionMoneda;


    constructor(public _currencyService:CurrencyService,private route: ActivatedRoute,private router: Router,private int:IntermService,private cs:CotizadorService,private pagerService: PagerService) {
        (this.da = new Date()).setDate(this.da.getDate() );
        this.model={estadia:0, origen:0, destino:0,tipo:0,inicio:"",fin:""}
    }

    getSelects() {
        this.cs.getOrigen().then(origen => {this.origen=origen;},error => {console.log("Error !!! " + error);});
        this.cs.getDestino().then(destino => {this.destino = destino;},error => {console.log("Error !!! " + error);});
        this.cs.getTipo().then(tipo => {this.tipo = tipo; },error => {console.log("Error !!! " + error);});
        this.cs.getEstadia().then(estadia => {this.estadia = estadia; },error => {console.log("Error !!! " + error);});
    }

    ngOnInit() {
        let scripts = new ScriptsModule;
        scripts.loadScript('assets/js/slider_fss.js');
        scripts.loadScript('assets/js/jquery.mousewheel.min.js');
        scripts.loadScript('assets/js/scripts/intermediarios-cotizacion.js');
        this.getSelects();

        var cotizacion=  localStorage.getItem('currentCotizacion');

        this.modelCotizacion= new Cotizacion(48,1,11,'','','',1,'','','','','','','','','','',false);
        this.route.params.subscribe(params => {
                this.id = +params['id']; // (+) converts string 'id' to a number
                if(this.id!=0){
                    $('#divCargador').show();
                    this.int.getCotizacion(this.id).then(resc => {

                    this.model=resc;

                    this.modelCotizacion.e1=this.model.e1;
                    this.modelCotizacion.e2=this.model.e2;
                    this.modelCotizacion.e3=this.model.e3;
                    this.modelCotizacion.e4=this.model.e4;
                    this.modelCotizacion.e5=this.model.e5;
                    this.modelCotizacion.e6=this.model.e6;
                    this.modelCotizacion.e7=this.model.e7;
                    this.modelCotizacion.e8=this.model.e8;

                    this.modelCotizacion.estadia=this.model.estadia;
                    this.modelCotizacion.origen=this.model.origen;
                    this.modelCotizacion.destino=this.model.destino;
                    this.modelCotizacion.tipo=this.model.tipo;
                    this.modelCotizacion.inicio=this.model.inicio;
                    this.modelCotizacion.fin=this.model.fin;

                    for(var i = 0; i <= this.model.polizas.length - 1; i++) {
                        this.model.polizas[i].seleccionar=true;
                    }

                    $('#divCargador').hide();
                });
            }
            else{
                this.model={
                    nombre:"",
                    correo:"",
                    telefono:"",
                    adicional:""
                };
                this.model.codigo=0;
                this.model.polizas=[];
                //this.modelCotizacion= new Cotizacion(48,1,11,'','','',1,'','','','','','','','','','',true);
            }
            });
        this.formatdate(this.da);
    }

    consultarPolizas(){
        localStorage.removeItem('currentPolizasComparar');
        this.model.polizas = []
        //ConsultarPolizas
        $('#divCargador').show();
        this.cs.getResCotizacion(JSON.stringify(this.modelCotizacion)).then(resc => {
                this.resCotizacion= resc;
                this.model.dias=this.resCotizacion.dias;
                this.model.pasajeros=this.resCotizacion.pasajeros;


            if (this.model.polizas==undefined || this.model.polizas.length==0){

                this.model.inicio=this.modelCotizacion.inicio;
                this.model.fin=this.modelCotizacion.fin;
            }
                this.polizas=this.resCotizacion.polizas;
                //validamos las polizas que ya estan en la cotizacion
                for(var i = 0; i <= this.resCotizacion.polizas.length - 1; i++) {
                    this.resCotizacion.polizas[i].seleccionar=this.existePolizaSeleccionada(this.resCotizacion.polizas[i].id);
                }
                this.setPage(1);
            $('#divCargador').hide();
            //$('#modalNotif').modal('show');
            $('#modalBusqueda').modal('show');

            });
    }

    agregarCotizacion(event):void{
        this.agregarPoliza(event.poliza);
    }

    agregarPoliza(poliza){
        if(!poliza.seleccionar){//Eliminar
            if(this.existePolizaSeleccionada(poliza.id)){// EXISTE LA POLIZA SELECCIONADA
                for(var i = 0; i <= this.model.polizas.length - 1; i++) {
                    if(this.model.polizas[i].id === poliza.id) {
                        this.model.polizas.splice(i,1);
                    }
                }
            }
        }
        else{//Agregar

            if (this.model.polizas.length<9){

                if(!this.existePolizaSeleccionada(poliza.id)){//NO EXISTE LA POLIZA SELECCIONADA
                    this.model.polizas.push(poliza);
                }
            }
            else
            {
                this.mensajeInterm="No se pueden agregar mas de 10 pólizas en una Cotización";
                this.rutaInterm="";

                $('#modalNotif').modal('show');
                poliza.seleccionar=false;
            }
        }
    }

    sendCotizacion(){

        if(this.model.codigo!=0){
        $('#divCargador').show();
            this.int.sendCotizacion(this.model.codigo).then(resc => {
                        $('#divCargador').hide();
                        if(resc.success==1){
                            this.mensajeInterm="Correo enviado exitoso";
                            this.rutaInterm="/intermediarios/plataforma";
                            $('#modalNotif').modal('show');
                        }
                        else{
                                this.mensajeInterm="Problema al  enviar";
                                this.rutaInterm="";
                                $('#modalNotif').modal('show');
                        }

                    });
        }
    }

    saveCotizacion(){

        if(this.validarCotizacionGuardar()){

                this.model.e1=this.modelCotizacion.e1;
                this.model.e2=this.modelCotizacion.e2;
                this.model.e3=this.modelCotizacion.e3;
                this.model.e4=this.modelCotizacion.e4;
                this.model.e5=this.modelCotizacion.e5;
                this.model.e6=this.modelCotizacion.e6;
                this.model.e7=this.modelCotizacion.e7;
                this.model.e8=this.modelCotizacion.e8;

                this.model.estadia=this.modelCotizacion.estadia;
                this.model.origen=this.modelCotizacion.origen;
                this.model.destino=this.modelCotizacion.destino;
                this.model.tipo=this.modelCotizacion.tipo;
                this.model.inicio=this.modelCotizacion.inicio;
                this.model.fin=this.modelCotizacion.fin;

            var usuario= JSON.parse(localStorage.getItem('currentUsuario'));
            this.model.idUsuario=usuario.id;
            this.model.idIntermediario=usuario.idIntermediario;

            $('#divCargador').show();
            this.int.saveCotizacion(JSON.stringify(this.model) ).then(resc => {
                        $('#divCargador').hide();

                        if(resc.succed){
                            this.mensajeInterm="Proceso exitoso";
                            this.rutaInterm="/intermediarios/plataforma";
                            $('#modalNotif').modal('show');
                            //this.router.navigate(['/intermediarios','cotizacion',resc.codigo]);
                        }
                        else{
                            this.mensajeInterm="Problemas al procesar la cotización";
                            this.rutaInterm="";
                            $('#modalNotif').modal('show');
                        }

                    });
        }
    }

    validarCotizacionGuardar(){

        var guarda=true;

        if(this.model.polizas.length==0){

            this.tituloInterm="Atención";
            this.mensajeInterm="Debe seleccionar al menos una poliza";
            this.rutaInterm="";
            $('#modalNotif').modal('show');
            guarda=false;

        }

        else if(this.model.nombre.trim()==''){

            this.mensajeInterm="Debe ingresar el nombre del cliente";
            this.rutaInterm="";
            $('#modalNotif').modal('show');
            guarda=false;

                }
        else if(this.model.correo.trim()==''){
            this.mensajeInterm="Debe ingresar el correo del cliente";
            this.rutaInterm="";
            $('#modalNotif').modal('show');
            guarda=false;
                }

        else if (this.model.codigo!=0){
            if(this.modelCotizacion.inicio!=this.model.inicio ||  this.modelCotizacion.fin!=this.model.fin){

                    this.mensajeInterm="Las fechas de la cotizacion cambiaron,debe eliminar las polizas  y recotizar!";
                    this.rutaInterm="";
                    $('#modalNotif').modal('show');
                    guarda=false;
            }
        }

        return guarda;
    }

    existePolizaSeleccionada(Id){

        var guarda=false;

        this.model.polizas.forEach(function(obj) {
            if(Id==obj.id){
                guarda=true;
                }
            });

        return guarda;
    }

    clausuladoPoliza(poliza){
        var ancho=800;
        var alto=500;
        var posicion_x;
        var posicion_y;
        posicion_x=(screen.width/2)-(ancho/2);
        posicion_y=(screen.height/2)-(alto/2);
        window.open(poliza.clausulado, "", "width="+ancho+",height="+alto+",menubar=0,toolbar=0,directories=0,scrollbars=no,resizable=no,left="+posicion_x+",top="+posicion_y+"");
    }

    detalleCoberturasPoliza(poliza){
        var ancho=800;
        var alto=500;
        var posicion_x;
        var posicion_y;
        posicion_x=(screen.width/2)-(ancho/2);
        posicion_y=(screen.height/2)-(alto/2);
        window.open(poliza.urlDetalleCobertura, "", "width="+ancho+",height="+alto+",menubar=0,toolbar=0,directories=0,scrollbars=no,resizable=no,left="+posicion_x+",top="+posicion_y+"");
    }

    setPage(page: number) {
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        // get pager object from service
        this.pager = this.pagerService.getPager(this.resCotizacion.polizas.length, page,4);
        // get current page of items
        this.pagedItems = this.resCotizacion.polizas.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

    formatdate(t){
        //var today = new Date();
        var dd = t.getDate();
        var mm = t.getMonth()+1; //January is 0!

        var yyyy = t.getFullYear();
        if(dd<10){
            dd='0'+dd;
        }
        if(mm<10){
            mm='0'+mm;
        }
        //2018-01-15
        var d = yyyy+'-'+mm+'-'+dd;
        document.getElementById("c_input").setAttribute("min", d);
    }

    conversionMonedas(posicion:any, indice:String) {
        if(this.resCotizacion.polizas[posicion - 1]) {
          let coleccion = JSON.stringify(this.resCotizacion.polizas[posicion - 1].conversionMoneda);
          this.conversionMoneda = JSON.parse(coleccion);
          let item = this.conversionMoneda.filter(x => x.id == indice)[0];
          return item.valor;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/intermediarios/cotizacion/cotizacion.component.ts